import React from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import classNames from "classnames";

const LogoTag = ({ tag, className, children, ...props }) => {
  const classes = classNames({ [className]: className });
  /**
   * If tag is an anchor, wraps it with nextJS' Link
   * component.
   */
  if (tag === "a") {
    return (
      <Link href={props.to}>
        <a className={classes}>{children}</a>
      </Link>
    );
  }

  return <div className={classes}>{children}</div>;
};

LogoTag.propTypes = {
  tag: PropTypes.oneOf(["a", "div"]),
  children: PropTypes.node.isRequired,
};

LogoTag.defaultProps = {
  tag: "a",
};

export default LogoTag;
